import React from 'react';
import { ListContext } from 'antd/lib/list';
import { List as AntdList } from 'antd';
import Item from './item';
import { ConfigContext } from '../config-provider';
function InnerList(props) {
    const { grid, itemLayout, prefixCls } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('list', prefixCls);
    return (React.createElement(ListContext.Provider, { value: { grid, itemLayout } },
        React.createElement(AntdList, { prefixCls: classPrefix, ...props })));
}
const List = InnerList;
List.Item = Item;
List.displayName = 'List';
// const ConfiguredList = withConfigProvider(List);
// export { ConfiguredList as List };
// export default ConfiguredList;
export default List;
